import { Injectable } from '@angular/core';

@Injectable()
export class AnimationFrameService
{

    rp_requestFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || (function (callback) { setTimeout(callback, 1000 / 60); });

    constructor() { }

    public getNextFrame(callback: Function)
    {
        const then: Date = new Date();

        this.rp_requestFrame(() =>
        {
            const now: Date = new Date();
            const dt = now.getTime() - then.getTime();

            callback(dt);
        });
    }

}
